import { render, staticRenderFns } from "./ShowUpdateClients.vue?vue&type=template&id=cab453bc&scoped=true"
import script from "./ShowUpdateClients.vue?vue&type=script&lang=js"
export * from "./ShowUpdateClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab453bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cab453bc')) {
      api.createRecord('cab453bc', component.options)
    } else {
      api.reload('cab453bc', component.options)
    }
    module.hot.accept("./ShowUpdateClients.vue?vue&type=template&id=cab453bc&scoped=true", function () {
      api.rerender('cab453bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/ShowUpdateClients.vue"
export default component.exports